import { Box, Flex } from 'styled-system/jsx';
import Typography from '@/common/components/base/typography/Typography';

type ProgressBarProps = {
  progress: number;
  showPercentage?: boolean;
};

const ProgressBar = ({ progress, showPercentage = true }: ProgressBarProps) => {
  return (
    <Box width="100%">
      <Flex flexDir="column" width="100%">
        <Box
          width="100%"
          height="8px"
          backgroundColor="gray-1"
          borderRadius="4px"
          overflow="hidden"
        >
          <Box
            height="100%"
            style={{ width: `${Math.min(100, Math.max(0, progress))}%` }}
            backgroundColor="purple-primary"
            borderRadius="4px"
            transition="width 0.3s ease"
            mr="auto"
          ></Box>
        </Box>
        {showPercentage && (
          <Typography
            textStyle="b2"
            color="black-1"
            mt={4}
            textAlign="left"
            ml="auto"
          >
            {`${Math.round(progress)}%`}
          </Typography>
        )}
      </Flex>
    </Box>
  );
};

export default ProgressBar;
